import React, {Suspense, useState} from 'react'
import PageLayout from '@view/layout/pageLayout/PageLayout'
import SpinnerCustom from '@ui/spinner/SpinnerCustom'
import {CamerasTableLazy} from '@containers/cameras/camerasTable/CamerasTable.lazy'
import {Box, Button, Stack, Typography} from '@mui/material'
import DashboardIcon from '@mui/icons-material/Dashboard'
import TableRowsIcon from '@mui/icons-material/TableRows'
import CamerasDashboard from '@containers/cameras/dashboard/CamerasDashboard'
import {useAppContext} from '@context/appContext/hooks/useAppContext'
import AccountAccentScope from '@containers/accountStyle/scope/AccountAccentScope'
import sx from '@pages/cameras/camerasList/sx'

type ViewMode = 'dashboard' | 'table'

const CamerasListPage = () => {
	const [mode, setMode] = useState<ViewMode>('dashboard')
	const {account} = useAppContext()

	return (
		<PageLayout>
			<AccountAccentScope>
				<Box sx={{height: '100%', display: 'flex', flexDirection: 'column'}}>
					<Box sx={sx.header}>
						<Typography variant="h6" sx={sx.title}>
							{mode === 'dashboard' ? 'Моніторинг камер' : 'Керування камерами'}
						</Typography>

						<Stack direction="row" spacing={1} sx={sx.actions}>
							<Button
								size="small"
								variant={mode === 'dashboard' ? 'contained' : 'outlined'}
								startIcon={<DashboardIcon/>}
								onClick={() => setMode('dashboard')}
							>
								Дашборд
							</Button>
							<Button
								size="small"
								variant={mode === 'table' ? 'contained' : 'outlined'}
								startIcon={<TableRowsIcon/>}
								onClick={() => setMode('table')}
							>
								Редагування
							</Button>
						</Stack>
					</Box>

					<Box sx={{flex: 1, overflow: 'auto'}}>
						{mode === 'dashboard' && (
							<CamerasDashboard accountId={account.id}/>
						)}

						{mode === 'table' && (
							<Suspense fallback={<SpinnerCustom/>}>
								<CamerasTableLazy/>
							</Suspense>
						)}
					</Box>
				</Box>
			</AccountAccentScope>
		</PageLayout>
	)
}

export default CamerasListPage
